module.exports = __webpack_public_path__ + "img/chat-46.a137d104.svg";